import { AuthRepository, LocalRepository } from '../repositories'

export interface LoginParamsBo extends AuthRepository.LoginReqDto {}

export interface LoginBo extends AuthRepository.LoginRespDto {}

/** 登入 */
export async function login({ account, password }: LoginParamsBo): Promise<LoginBo> {
  const loginDto = await AuthRepository.login({ account, password })

  await LocalRepository.setToken(loginDto.accessToken)

  return loginDto;
}
